import { checkRole } from '@/constants';

// Страницы, куда пускаем без проверки роли
const PUBLIC_PAGES = ['error-403', 'error-404', 'auth'];

type AccessRoute = {
    name?:     string | null;
    fullPath?: string;
    meta?:     { rule?: string };
};

type AccessUser = {
    isAuthorized: boolean;
    isPro:        boolean;
    userRole?:    string;
};

export type AccessRedirect = { name: string } | string;

/**
 * Куда перенаправить при переходе на страницу; null — пускаем
 *
 * @param to - куда идём
 * @param from - откуда пришли
 * @param user - сессия пользователя
 */
export function getAccessRedirect(
    to: AccessRoute,
    from: AccessRoute,
    user: AccessUser,
): AccessRedirect | null {
    const rule = to.meta?.rule;
    const canSeePage = rule ? checkRole(rule, user.userRole ?? '') : true;
    const toName = to.name ?? '';

    if (!user.isAuthorized && !canSeePage && rule && !PUBLIC_PAGES.includes(toName)) {
        return { name: 'auth' };
    }

    if (user.isAuthorized && (!canSeePage || !user.isPro) && toName !== 'error-403') {
        return { name: 'error-403' };
    }

    if (user.isAuthorized && toName === 'auth') {
        const fromName = from.name ?? '';

        return fromName && !PUBLIC_PAGES.includes(fromName) && from.fullPath ? from.fullPath : '/';
    }

    return null;
}
